export default "__VITE_ASSET__CnOxR80a__"